/**
 * API Vụ án – POC dùng mock; triển khai thật dùng cùng endpoint với backend.
 */
import { apiSlice } from './apiSlice'
import type { Case, CaseDetail, CaseCreate, CaseFilters } from '../../types/case'

export const casesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCases: builder.query<Case[], CaseFilters | void>({
      query: (filters) => {
        const params = new URLSearchParams()
        if (filters?.status) params.set('status', filters.status)
        if (filters?.track) params.set('track', filters.track)
        const q = params.toString()
        return { url: q ? `cases?${q}` : 'cases', method: 'GET' }
      },
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: 'Cases' as const, id })), 'Cases'] : ['Cases'],
    }),
    getCaseById: builder.query<CaseDetail, string>({
      query: (id) => ({ url: `cases/${id}`, method: 'GET' }),
      providesTags: (_result, _err, id) => [{ type: 'Case', id }],
    }),
    createCase: builder.mutation<Case, CaseCreate>({
      query: (body) => ({ url: 'cases', method: 'POST', body }),
      invalidatesTags: ['Cases'],
    }),
    assignJudge: builder.mutation<{ success: boolean }, { case_id: string; judge_id: string }>({
      query: ({ case_id, judge_id }) => ({
        url: `cases/${case_id}/assign`,
        method: 'POST',
        body: { judge_id },
      }),
      invalidatesTags: (_result, _err, { case_id }) => ['Cases', { type: 'Case', id: case_id }],
    }),
    updateCaseStatus: builder.mutation<Case, { case_id: string; status: Case['status'] }>({
      query: ({ case_id, status }) => ({
        url: `cases/${case_id}`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: (_result, _err, { case_id }) => ['Cases', { type: 'Case', id: case_id }],
    }),
  }),
})

export const { useGetCasesQuery, useGetCaseByIdQuery, useCreateCaseMutation, useAssignJudgeMutation, useUpdateCaseStatusMutation } = casesApi
